import { enableProdMode } from '@angular/core';
import localeRu from '@angular/common/locales/ru';
import { environment } from '@lentau/core/environments';

import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { appBrowserConfig } from './app/app.config';
import { recoverFromBootstrapError } from '@lentau/core/runtime-recovery/application/recovery/bootstrap-runtime-recovery';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeRu);

bootstrapApplication(AppComponent, appBrowserConfig).catch((error: unknown) => recoverFromBootstrapError(error));
